import { gql } from '@apollo/client';
/**
 * @const ImportSaleItemOptionRelationsMutation
 * @since 1.0.0
 */
export const ImportSaleItemOptionRelationsMutation = gql `
  mutation ImportSaleItemOptionRelationsMutation($input: ImportSaleItemOptionRelationsInput!) {
    importSaleItemOptionRelations(input: $input)
  }
`;
